const READABLE_SELECTOR = "h1, h2, h3, h4, h5, h6, p, li, blockquote, td, th";
const SKIP_SELECTOR = [
  "pre",
  "code",
  ".code-block",
  "button",
  "input",
  "select",
  "textarea",
  "iframe",
  "svg",
  "script",
  "style",
  "[hidden]",
  "[aria-hidden='true']",
].join(", ");

const normalizeSpeechText = (value) =>
  String(value || "")
    .replace(/\s+/g, " ")
    .trim();

const clearPreviousChunkIds = (rootElement) => {
  rootElement
    .querySelectorAll("[data-speech-chunk-id]")
    .forEach((element) => element.removeAttribute("data-speech-chunk-id"));
};

const isElementHidden = (element) => {
  if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;

  if (element.hidden || element.getAttribute("aria-hidden") === "true") {
    return true;
  }

  const style =
    typeof window !== "undefined" && window.getComputedStyle
      ? window.getComputedStyle(element)
      : null;

  return (
    style?.display === "none" ||
    style?.visibility === "hidden" ||
    style?.visibility === "collapse"
  );
};

const hasHiddenAncestor = (element, rootElement) => {
  let currentElement = element;

  while (currentElement && currentElement !== rootElement) {
    if (isElementHidden(currentElement)) return true;
    currentElement = currentElement.parentElement;
  }

  return false;
};

const hasReadableAncestor = (element, rootElement) => {
  let currentElement = element.parentElement;

  while (currentElement && currentElement !== rootElement) {
    if (currentElement.matches(READABLE_SELECTOR)) return true;
    currentElement = currentElement.parentElement;
  }

  return false;
};

export function extractSpeechChunks(rootElement, options = {}) {
  if (!rootElement || rootElement.nodeType !== Node.ELEMENT_NODE) {
    return [];
  }

  const {
    readableSelector = READABLE_SELECTOR,
    skipSelector = SKIP_SELECTOR,
    minTextLength = 1,
  } = options;

  clearPreviousChunkIds(rootElement);

  return Array.from(rootElement.querySelectorAll(readableSelector))
    .filter((element) => {
      if (element.closest(skipSelector)) return false;
      if (hasHiddenAncestor(element, rootElement)) return false;
      if (hasReadableAncestor(element, rootElement)) return false;

      const text = normalizeSpeechText(element.textContent);
      return text.length >= minTextLength;
    })
    .map((element, index) => {
      const id = `speech-chunk-${index}`;
      element.dataset.speechChunkId = id;

      return {
        id,
        text: normalizeSpeechText(element.textContent),
        element,
        tagName: element.tagName.toLowerCase(),
      };
    });
}

export { normalizeSpeechText };
